import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { GemstoneArrangementWithSetting } from 'src/app/interfaces/gemstone-arrangement-with-setting';
import { StoneArrangementsWithSettingsProviderService } from 'src/app/providers/stone-arrangementsWithSettings/stone-arrangements-with-settings.provider.service';

@Injectable({
  providedIn: 'root'
})
export class StoneArrangementsWithSettingsService extends ApiService<GemstoneArrangementWithSetting, StoneArrangementsWithSettingsProviderService> {
  private providerService = inject(StoneArrangementsWithSettingsProviderService);
  protected override get provider(): StoneArrangementsWithSettingsProviderService {
    return this.providerService;
  }
}